import script from "./MatchTutorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchTutorPage.vue?vue&type=script&setup=true&lang=js"

import "./MatchTutorPage.vue?vue&type=style&index=0&id=584ac93b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-584ac93b"]])

export default __exports__